'use strict';

var _ = require('lodash');
var GridAddSpecialEventButtonController = function GridAddSpecialEventButtonController($scope, seasonalityConstants, specialEventsGridService, featureToggleService) {
  var gridPanel = $scope.gridPanelScope;
  function checkCalendarStatus(status) {
    return status === seasonalityConstants.CALENDAR_STATUSES.COMPLETED || status === seasonalityConstants.CALENDAR_STATUSES.FINISHED;
  }
  $scope.enableAddSpecialEvent = true;
  $scope.onRowSelection = function () {
    if (gridPanel.gridId !== seasonalityConstants.SPECIAL_EVENTS_GRID_ID) {
      return;
    }
    var movingEvents = _.filter(gridPanel.localData, {
      eventType: seasonalityConstants.SPECIAL_EVENT_TYPES.MOVING
    });
    $scope.enableAddSpecialEvent = movingEvents.length > 0 && checkCalendarStatus($scope.calendarStatus);
  };
  $scope.addSpecialEvent = function () {
    specialEventsGridService.addRow(gridPanel);
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && $scope.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND) {
      $scope.$emit('pooled-seasonality-special-events:showSpecialEventsFromParent', true);
    }
  };
  $scope.handleSpecialEventUpdates = function (newSplEventsList, oldSplEventsList) {
    if (!_.isEqual(newSplEventsList, oldSplEventsList)) {
      $scope.onRowSelection();
    }
  };
};
GridAddSpecialEventButtonController.$inject = ['$scope', 'SeasonalityConstants', 'SpecialEventsGridService', 'FeatureToggleService'];
module.exports = GridAddSpecialEventButtonController;